import { render, staticRenderFns } from "./printLabel.vue?vue&type=template&id=6b0df63c&scoped=true&"
import script from "./printLabel.vue?vue&type=script&lang=js&"
export * from "./printLabel.vue?vue&type=script&lang=js&"
import style0 from "./printLabel.vue?vue&type=style&index=0&id=6b0df63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0df63c",
  null
  
)

export default component.exports